export type SupportedLocales = {
  defaultLocale: string;
  locales: Array<string>;
};

export const fetchSupportedLocales = async (): Promise<SupportedLocales> => {
  const response = await fetch(`/api/contentful/locales`);
  const { default: defaultLocale, locales } = await response.json();

  // If Contentful CMS supports english language then make en-IN locale as the default locale
  // and bring en-IN to 0 index to be picked by getPreferredLocale function in ForwardToLocaleRoute component
  const updatedLocales = locales.includes("en-IN")
    ? ["en-IN", ...locales.filter((l: string) => l !== "en-IN")]
    : locales;

  return {
    defaultLocale: locales.includes("en-IN") ? "en-IN" : defaultLocale,
    locales: updatedLocales,
  };
};
